<div class="card">
  <div class="card-header card-header-squirrel text-center">
    <h4>Bitte bestätigen Sie diesen Hinweis</h4>
    <!-- <h4>{{this.translate.data['TOOLTIPREMOVEUSER'] | translate}}</h4> -->
  </div>

  <div class="card-body">
    Die Datenbank des Mandanten ist nicht auf dem neuesten Stand. Bitte informieren Sie den Administrator. Sie können mit ihrer Arbeit fortfahren, aber es kann zu Fehlern kommen.
          <!-- <mat-form-field class="example-full-width" style="width: 0; height: 0;">
              <input matInput hidden formControlName="id" readonly>
          </mat-form-field>
  
          <mat-form-field class="example-full-width">
              <input matInput formControlName="userName" readonly>
          </mat-form-field> -->
          <button mat-raised-button class="btn btn-squirrel pull-right" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
              (click)="confirm()" >OK</button>
  </div>
</div>
